import script from "./detailjiaoxuerizhi.vue?vue&type=script&setup=true&lang=js"
export * from "./detailjiaoxuerizhi.vue?vue&type=script&setup=true&lang=js"

import "./detailjiaoxuerizhi.vue?vue&type=style&index=0&id=2bc47320&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bc47320"]])

export default __exports__